import React from 'react';

import { translate } from '~l10n/client';

import { VideoErrorIcon } from '~shared/components/MediaPlayer/icons/VideoErrorIcon';

export const VideoErrorScreen = ({ onRetry }: { onRetry: () => void }) => (
  <div
    data-testid="media-error-screen"
    className="activity-media-container video-error-container"
  >
    <VideoErrorIcon />
    <p>{translate('Unexpected Error')}</p>
    <button onClick={onRetry}>{translate('Retry')}</button>
  </div>
);
